var _rect, _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoftwareservices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 336,
    height: 94,
    viewBox: "0 0 336 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 336,
    height: 94,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.276 62.45C138.212 62.45 137.4 62.156 136.84 61.568C136.28 60.98 136 60.154 136 59.09V35.444C136 34.38 136.28 33.554 136.84 32.966C137.4 32.378 138.212 32.084 139.276 32.084C140.312 32.084 141.11 32.378 141.67 32.966C142.23 33.554 142.51 34.38 142.51 35.444V59.09C142.51 60.154 142.23 60.98 141.67 61.568C141.138 62.156 140.34 62.45 139.276 62.45Z",
    fill: "url(#paint0_linear_3558_182388)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M151.871 62.072C150.779 62.072 149.939 61.778 149.351 61.19C148.763 60.602 148.469 59.762 148.469 58.67V35.864C148.469 34.772 148.763 33.932 149.351 33.344C149.939 32.756 150.779 32.462 151.871 32.462H160.061C165.129 32.462 169.035 33.75 171.779 36.326C174.551 38.874 175.937 42.514 175.937 47.246C175.937 49.626 175.573 51.74 174.845 53.588C174.145 55.408 173.123 56.948 171.779 58.208C170.435 59.468 168.783 60.434 166.823 61.106C164.863 61.75 162.609 62.072 160.061 62.072H151.871ZM154.979 56.738H159.683C161.279 56.738 162.665 56.542 163.841 56.15C165.017 55.758 165.997 55.17 166.781 54.386C167.565 53.602 168.153 52.622 168.545 51.446C168.937 50.242 169.133 48.842 169.133 47.246C169.133 44.054 168.335 41.688 166.739 40.148C165.171 38.58 162.819 37.796 159.683 37.796H154.979V56.738Z",
    fill: "url(#paint1_linear_3558_182388)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M184.27 62.45C183.206 62.45 182.394 62.156 181.834 61.568C181.274 60.98 180.994 60.154 180.994 59.09V35.78C180.994 34.688 181.274 33.862 181.834 33.302C182.422 32.742 183.248 32.462 184.312 32.462H194.518C197.822 32.462 200.37 33.26 202.162 34.856C203.954 36.452 204.85 38.678 204.85 41.534C204.85 43.382 204.444 44.978 203.632 46.322C202.82 47.666 201.644 48.702 200.104 49.43C198.592 50.158 196.73 50.522 194.518 50.522L194.854 49.808H196.576C197.752 49.808 198.774 50.102 199.642 50.69C200.538 51.25 201.308 52.118 201.952 53.294L204.556 58.124C204.948 58.824 205.13 59.51 205.102 60.182C205.074 60.854 204.822 61.4 204.346 61.82C203.87 62.24 203.17 62.45 202.246 62.45C201.322 62.45 200.566 62.254 199.978 61.862C199.418 61.47 198.914 60.868 198.466 60.056L194.434 52.622C194.014 51.838 193.496 51.306 192.88 51.026C192.292 50.746 191.564 50.606 190.696 50.606H187.504V59.09C187.504 60.154 187.224 60.98 186.664 61.568C186.132 62.156 185.334 62.45 184.27 62.45ZM187.504 45.902H193.342C195.078 45.902 196.38 45.552 197.248 44.852C198.144 44.152 198.592 43.102 198.592 41.702C198.592 40.33 198.144 39.294 197.248 38.594C196.38 37.894 195.078 37.544 193.342 37.544H187.504V45.902Z",
    fill: "url(#paint2_linear_3558_182388)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M213.262 62.45C212.31 62.45 211.582 62.184 211.078 61.652C210.574 61.12 210.322 60.378 210.322 59.426V35.108C210.322 34.156 210.588 33.414 211.12 32.882C211.68 32.35 212.436 32.084 213.388 32.084C214.228 32.084 214.886 32.252 215.362 32.588C215.866 32.896 216.328 33.442 216.748 34.226L226.45 51.95H225.022L234.724 34.226C235.144 33.442 235.592 32.896 236.068 32.588C236.572 32.252 237.23 32.084 238.042 32.084C238.994 32.084 239.722 32.35 240.226 32.882C240.758 33.414 241.024 34.156 241.024 35.108V59.426C241.024 60.378 240.772 61.12 240.268 61.652C239.764 62.184 239.036 62.45 238.084 62.45C237.132 62.45 236.39 62.184 235.858 61.652C235.354 61.12 235.102 60.378 235.102 59.426V42.416H236.026L228.214 56.402C227.878 56.934 227.514 57.34 227.122 57.62C226.758 57.872 226.268 57.998 225.652 57.998C225.036 57.998 224.532 57.858 224.14 57.578C223.748 57.298 223.398 56.906 223.09 56.402L215.194 42.374H216.202V59.426C216.202 60.378 215.95 61.12 215.446 61.652C214.97 62.184 214.242 62.45 213.262 62.45Z",
    fill: "url(#paint3_linear_3558_182388)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M257.613 62.534C256.437 62.534 255.233 62.436 254.001 62.24C252.797 62.072 251.635 61.82 250.515 61.484C249.423 61.148 248.443 60.728 247.575 60.224C246.959 59.888 246.525 59.454 246.273 58.922C246.021 58.362 245.923 57.802 245.979 57.242C246.063 56.682 246.273 56.192 246.609 55.772C246.973 55.324 247.421 55.044 247.953 54.932C248.513 54.792 249.129 54.89 249.801 55.226C250.949 55.87 252.195 56.346 253.539 56.654C254.911 56.962 256.269 57.116 257.613 57.116C259.657 57.116 261.113 56.808 261.981 56.192C262.849 55.548 263.283 54.75 263.283 53.798C263.283 52.986 262.975 52.342 262.359 51.866C261.743 51.39 260.665 50.984 259.125 50.648L254.379 49.64C251.691 49.08 249.689 48.128 248.373 46.784C247.085 45.412 246.441 43.62 246.441 41.408C246.441 40.008 246.735 38.734 247.323 37.586C247.911 36.438 248.737 35.444 249.801 34.604C250.865 33.764 252.125 33.12 253.581 32.672C255.065 32.224 256.689 32 258.453 32C260.021 32 261.561 32.196 263.073 32.588C264.585 32.952 265.915 33.498 267.063 34.226C267.623 34.562 268.001 34.996 268.197 35.528C268.421 36.032 268.491 36.55 268.407 37.082C268.351 37.586 268.141 38.034 267.777 38.426C267.441 38.818 267.007 39.07 266.475 39.182C265.943 39.294 265.299 39.168 264.543 38.804C263.619 38.328 262.639 37.978 261.603 37.754C260.567 37.53 259.503 37.418 258.411 37.418C257.235 37.418 256.227 37.572 255.387 37.88C254.575 38.188 253.945 38.622 253.497 39.182C253.077 39.742 252.867 40.386 252.867 41.114C252.867 41.926 253.161 42.584 253.749 43.088C254.337 43.592 255.359 43.998 256.815 44.306L261.561 45.314C264.305 45.902 266.349 46.854 267.693 48.17C269.037 49.458 269.709 51.166 269.709 53.294C269.709 54.694 269.429 55.968 268.869 57.116C268.309 58.236 267.497 59.202 266.433 60.014C265.369 60.826 264.095 61.456 262.611 61.904C261.127 62.324 259.461 62.534 257.613 62.534Z",
    fill: "url(#paint4_linear_3558_182388)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5003 58.5005C71.1669 57.3338 63.5 50.4005 66.5003 42.0005C69.0005 35.0006 77.0004 34 81.5004 35.0005C82.6671 30.8338 87.3004 22.6004 96.5004 23.0004C108.5 23.5221 111 32 111 37.5C115.5 37 123.167 41 122.5 49C122 55 115.5 60 108 60",
    stroke: "url(#paint5_linear_3558_182388)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 37,
    r: 6,
    fill: "url(#paint6_linear_3558_182388)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.5 45H91L80 60.5H91.5L84.5 76L105 55.5H93L101.5 45Z",
    fill: "url(#paint7_linear_3558_182388)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3558_182388",
    x1: 137.518,
    y1: 48.0723,
    x2: 268.518,
    y2: 48.0723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC79FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#571EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3558_182388",
    x1: 137.518,
    y1: 48.0723,
    x2: 268.518,
    y2: 48.0723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC79FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#571EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3558_182388",
    x1: 137.518,
    y1: 48.0723,
    x2: 268.518,
    y2: 48.0723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC79FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#571EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3558_182388",
    x1: 137.518,
    y1: 48.0723,
    x2: 268.518,
    y2: 48.0723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC79FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#571EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3558_182388",
    x1: 137.518,
    y1: 48.0723,
    x2: 268.518,
    y2: 48.0723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC79FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#571EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3558_182388",
    x1: 66,
    y1: 43.5,
    x2: 124.5,
    y2: 49.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#581FAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD7AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3558_182388",
    x1: 91,
    y1: 37.5,
    x2: 103,
    y2: 37.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFED90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3558_182388",
    x1: 81,
    y1: 58.5,
    x2: 102.5,
    y2: 58.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3C031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEC8F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareservices);
export default __webpack_public_path__ + "static/media/softwareservices.c3d2b87baead43556bd12d01879e7018.svg";
export { ForwardRef as ReactComponent };